import type { BackendModule, ResourceLanguage } from 'i18next';
import en from './translation/en.json';

const loaders = import.meta.glob<ResourceLanguage>(
  [
    './translation/*.json',
    './translation/entry/*.json',
    '!./translation/en.json',
    '!./translation/entry/scope.json',
  ],
  { import: 'default' },
);
const languageLoads = new Map<string, Promise<ResourceLanguage>>();

export const loadTranslation = (language: string): Promise<ResourceLanguage> => {
  if (language === 'en') return Promise.resolve(en);
  const pending = languageLoads.get(language);
  if (pending) return pending;
  const load =
    loaders[`./translation/${language}.json`] ?? loaders[`./translation/entry/${language}.json`];
  if (!load) return Promise.reject(new Error(`Unsupported interface language: ${language}`));
  const request = load();
  languageLoads.set(language, request);
  return request;
};

export const translationBackend: BackendModule = {
  type: 'backend',
  init: () => {},
  read: (language, namespace, callback) => {
    loadTranslation(language).then(
      (resources) => callback(null, resources[namespace] ?? {}),
      (error: unknown) =>
        callback(error instanceof Error ? error : new Error(String(error)), false),
    );
  },
};
